import React, { useState } from "react";
import "./DispenseSolution.scss";
import P200Plunger from "./assets/P200-Plunger.svg";
import P200TipSolutionBlue from "./assets/P200-Tip-Solution-Blue.svg";
import arrow from "./assets/arrow.svg";

interface DispenseSolutionProps {
  onPlungerPress: () => void;
}

const DispenseSolution: React.FC<DispenseSolutionProps> = ({
  onPlungerPress,
}) => {
  const [plungerPosition, setPlungerPosition] = useState(false);

  const handlePlungerPress = () => {
    setPlungerPosition(true);
    onPlungerPress();
    setTimeout(() => {
      setPlungerPosition(false);
    }, 500);
  };

  return (
    <div className="dispense-solution">
      <h2>Dispense solution</h2>
      <p className="instructions">
        Press the plunger down to the second stop to dispense the liquid into
        the well.
      </p>

      <div className="plunger-section">
        <div className="section-header">Press the plunger down.</div>

        <div className="pipette-visualization">
          <div className="plunger-levels">
            <div className="level">
              <div className="level-label">
                Release
                <div className="level-line"></div>
              </div>
            </div>
            <div className="level">
              <div className="level-label">
                1st
                <div className="level-line"></div>
              </div>
            </div>
            <div className="level">
              <div className="level-label">
                2nd
                <div className="level-line"></div>
              </div>
            </div>
          </div>
          <button className="plunger-press-button" onClick={handlePlungerPress}>
            &nbsp;
          </button>
          <img src={arrow} alt="Arrow" className="arrow-svg" />
          <img
            src={P200Plunger}
            alt="P200 Plunger"
            className={`pipette-plunger ${
              plungerPosition ? "plunger-down" : ""
            }`}
          />
          <img
            src={P200TipSolutionBlue}
            alt="P200 Tip With Solution Blue"
            className="pipette-body"
          />
        </div>
      </div>
    </div>
  );
};

export default DispenseSolution;
